import { AppThunk } from '../../index'
import { usersServices } from '../../App'

export const refreshUsersThunk = (podId: string): AppThunk => async dispatch => {
  try {
    await dispatch(usersServices.users.find({ query: { podId } }))
  } catch (e) {
    console.log(e.message)
  }
}